import { z } from 'zod'
import { CountryCode } from 'libphonenumber-js'

import i18n from '@src/i18n/i18n'
import { isValidPhoneNumber } from '@src/utils/isValidPhoneNumber'

const t = (key: string) => i18n.t(key, { ns: 'addBusiness' })

export const addBusinessSchema = (countryCode: CountryCode) =>
  z.object({
    businessName: z
      .string({ required_error: t('business_name.required') })
      .min(3, t('business_name.invalid_length')),
    businessEmail: z
      .string({
        required_error: t('business_email.required'),
        invalid_type_error: t('business_email.invalid_format'),
      })
      .email(),
    businessPhone: z
      .string({ required_error: t('business_phone.required') })
      .min(10, t('business_phone.required'))
      .refine(
        val => isValidPhoneNumber(val, countryCode),
        t('business_phone.invalid_format')
      ),
    firstLine: z
      .string({
        required_error: t('owner_address.first_line.required'),
      })
      .regex(/\w+/, t('owner_address.first_line.invalid_format')),
    secondLine: z
      .string({ required_error: t('owner_address.second_line.required') })
      .regex(/\w+/, t('owner_address.second_line.invalid_chars'))
      .min(2, t('owner_address.second_line.invalid_length')),
    city: z
      .string({ required_error: t('owner_address.city.required') })
      .min(2, t('owner_address.city.invalid_length')),
    postcode: z.string({
      required_error: t('owner_address.postcode.required'),
    }),
    countryCodeStr: z.string({
      required_error: t('owner_address.country_code.required'),
    }),
    ownerName: z.string({ required_error: t('owner_name.required') }),
  })
